import { TourTypes } from '../../types';
import { SceneData, TourResponseTypes } from '../../types/response';

const getSceneThumbnail = (scene: SceneData): string => {
  return scene.sourceFolder
    ? `${scene.sourceFolder.url}/${scene.sourceFolder.originalName}.tiles/thumb.jpg`
    : '';
};

export const convertTourResponse = (item: TourResponseTypes & { uri: string }): TourTypes => {
  const firstScene = item.scenes && item.scenes[0];
  const thumb = firstScene && getSceneThumbnail(firstScene);

  return { code: item.code, name: item.name, uri: item.uri, url: thumb };
};
